import React from 'react'
import styled from 'styled-components'
import Table from 'components/Table'

import { MetricCharts } from 'types/DeviceMetric'
import { screenSize } from 'styles/shared'

const ChartLimitTable = ({ charts }: MetricCharts) => {
  if (charts.length === 0) {
    return <p>None</p>
  }

  if (charts.length === 1 && charts[0].class === null) {
    return <p>All</p>
  }

  return (
    <Table
        items={charts}
        noDataMessage={{
          title: '',
          description: ''
        }}
    >
      <Table.Header>
        <S.HeaderCell title="Class" />
        <S.HeaderCell title="Hight Green" />
        <S.HeaderCell title="High Red" />
        <S.HeaderCell title="High Yellow" />
        <S.HeaderCell title="Low Green" />
        <S.HeaderCell title="Low Red" />
        <S.HeaderCell title="Low Yellow" />
      </Table.Header>

      {charts.map(chart => (
        <div key={chart.class}>
          <S.TableRow>
            <S.Cell>
              <S.SmallScreenLabel>Class:</S.SmallScreenLabel>
              <p>{chart.class}</p>
            </S.Cell>
            <S.Cell>
              <S.SmallScreenLabel>High Green:</S.SmallScreenLabel>
              <p>{chart.highGreen}</p>
            </S.Cell>
            <S.Cell>
              <S.SmallScreenLabel>High Red:</S.SmallScreenLabel>
              <p>{chart.highRed}</p>
            </S.Cell>
            <S.Cell>
              <S.SmallScreenLabel>High Yellow:</S.SmallScreenLabel>
              <p>{chart.highYellow}</p>
            </S.Cell>
            <S.Cell>
              <S.SmallScreenLabel>Low Green:</S.SmallScreenLabel>
              <p>{chart.lowGreen}</p>
            </S.Cell>
            <S.Cell>
              <S.SmallScreenLabel>Low Red:</S.SmallScreenLabel>
              <p>{chart.lowRed}</p>
            </S.Cell>
            <S.Cell>
              <S.SmallScreenLabel>Low Yellow:</S.SmallScreenLabel>
              <p>{chart.lowYellow}</p>
            </S.Cell>
          </S.TableRow>
        </div>
      ))}
    </Table>
  )
}

export default ChartLimitTable

const S = {
  HeaderCell: styled(Table.HeaderCell)`
    flex: 1;
  `,
  TableRow: styled(Table.Row)`
    align-items: center;
  `,
  Cell: styled(Table.Cell)`
    flex: 1;
    line-height: 24px;
    text-overflow: ellipsis;
    padding: 20px 8px;
    overflow: hidden;

    @media ${screenSize.medium} {
      line-height: inherit;
      padding: 10px 8px;
    }
    @media ${screenSize.small} {
      line-height: inherit;
      padding: 10px 5px;
    }

    @media ${screenSize.small} {
      display: inline-block;
      width: 100%;
      padding: 5px;
      line-height: 20px;
    }
  `,
  Header: styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
    
    @media ${screenSize.small} {
      justify-content: end;
    }
  `,
  SmallScreenLabel: styled.div`
    display: none;
    font-weight: bold;

    @media ${screenSize.small} {
      display: block;
      padding-right: 10px;
    }
  `
}
